import React from "react";
import object from "./city.json";
import "./ListCityes.css";
const ListCities = () => {
  return (
    <div className="city-container">
      {object.map((city, index) => (
        <div className="city-card" key={index}>
          <img src={city.image} alt={city.name} className="city-image" />
          <h3 className="city-name">{city.name}</h3>
          <p className="city-subtext">{city.subText}</p>
        </div>
      ))}
    </div>
  );
};

export default ListCities;
